export const uiGlobalQueryKeys = {
  users: ['users'],
};
